import { BarDatum } from '@nivo/bar';
import {
  AiVisualisationResponseFragment,
  DatasetObjectQueryColumn,
  DatasetObjectQueryResponse,
} from '@warebee/frontend/data-access-api-graphql';
import _ from 'lodash';
import useFormatter from '../common/useFormatter';
import useGetNamedColor from '../common/useGetNamedColor';
import { cn } from '../common/utils';
import StackedBar, { StackedBarProps } from '../components/charts/StackedBar';
import SimulationPieChart from '../simulation/panels/SimulationPieChart';
import { getPieChartData } from './store/aiAgent.chart.helper';
import { getColumnDataFormatter } from './store/aiAgent.helper';

type AiChartType = 'table' | 'bar' | 'pie' | 'groupped-bar';
export type AiAgentResponseChartProps = {
  messageId: string;
  visualisationType: AiVisualisationResponseFragment;
  queryResponse: DatasetObjectQueryResponse;
};

const AiAgentResponseChart: React.FC<AiAgentResponseChartProps> = props => {
  const formatter = useFormatter();
  const getNamedColor = useGetNamedColor();
  const suggestedType = props.visualisationType
    ?.visualizationType as AiChartType;

  const showPieChart = suggestedType === 'pie';
  const showBarType =
    suggestedType === 'bar' || suggestedType === 'groupped-bar';

  const getColumnFormatter = (column: DatasetObjectQueryColumn) =>
    getColumnDataFormatter(column || null, formatter);

  function getChart() {
    if (showPieChart) {
      return (
        <SimulationPieChart
          data={getPieChartData({
            visualisationType: props.visualisationType,
            queryResponse: props.queryResponse,
            getColor: getNamedColor,
            getFormatter: getColumnFormatter,
          })}
        />
      );
    }
    if (showBarType) {
      const indexBy = _.head(props.visualisationType?.dimensionColumns);
      const dimensions =
        _.tail(props.visualisationType?.dimensionColumns) || [];
      if (_.isEmpty(dimensions)) {
        dimensions.push(indexBy);
      }
      const dim = _.head(dimensions);
      const dataKeys = _(props.queryResponse.result)
        .map(r => r[dim])
        .uniq()
        .value();
      const metricField = props.visualisationType?.metricColumn;
      const col = _.find(
        props.queryResponse.columns,
        c => c.name === metricField,
      );
      const getFormatted = getColumnFormatter(col || null);

      const chartProps: StackedBarProps<BarDatum> = {
        data: _.map(props.queryResponse.result, row => {
          return _.reduce(
            dimensions,
            (acc, dimension) => ({
              ...acc,
              [row[dimension]]: row[metricField],
            }),
            {
              [indexBy]: row[indexBy],
            },
          );
        }),
        getColor: d => _.head(getNamedColor(d.id as string)),
        getLabel: d => d.id?.toString(),
        indexBy: indexBy,
        dataKeys: dataKeys,
        valueFormatter: getFormatted,
      };

      return <StackedBar {...chartProps} />;
    }
  }

  const chartData = getChart();

  return (
    <div className="m-4 flex h-fit flex-col">
      {chartData && (
        <div
          className={cn('h-[24rem] w-full', {
            // 'h-[16rem]': chartType === 'velocity-distribution',
          })}
        >
          {getChart()}
        </div>
      )}
    </div>
  );
};

export default AiAgentResponseChart;
